export default "__VITE_ASSET__d756a431__"